const errUnknownDb = new Error('Error getting collection: unknown type')

// Generic getters

// get a db
export const db = state => name => {
  return state[name]
}

// get a collection of documents
export const allDocs = state => (collection, opts = { include_docs: true }) => {
  return new Promise((resolve, reject) => {
    if (!state[collection]) reject(errUnknownDb)
    state[collection].allDocs(opts)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

// get a document from a collection
export const doc = state => (collection, id, opts = {}) => {
  return new Promise((resolve, reject) => {
    if (!state[collection]) reject(errUnknownDb)
    state[collection].get(id, opts)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

// find with a mango query
// https://pouchdb.com/guides/mango-queries.html#query-language
export const find = state => (collection, query) => {
  return new Promise((resolve, reject) => {
    if (!state[collection]) reject(errUnknownDb)
    state[collection].find(query)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

// returns a liveFeed
// https://github.com/colinskow/pouchdb-live-find#basic-usage
export const live = state => (collection, query) => {
  return state[collection].liveFind(query)
}
